module.exports = __webpack_public_path__ + "img/icon_blue-big_lock.55a09197.svg";